import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, Facebook, Clock } from "lucide-react";
import { CONTACT } from "@/data/site";
import Logo from "@/components/Logo";

function XIcon({ className }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.66l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#0B1B3D] text-white">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <Logo variant="white" asLink={false} />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-300">
              Professional document preparation for self-represented individuals. A service
              division of Summers Administrative Group.
            </p>
            <div className="mt-5 inline-flex items-center gap-2 rounded-md border border-[#D4AF37]/40 px-3 py-1.5 text-sm text-[#D4AF37]">
              <Clock className="h-4 w-4" /> 24 Hour Delivery
            </div>
          </div>

          <div>
            <h4 className="section-label text-[#D4AF37]">Navigate</h4>
            <ul className="mt-5 space-y-3 text-sm text-slate-300">
              {[
                { label: "Home", to: "/" },
                { label: "Services", to: "/services" },
                { label: "Consumer & Legal Resources", to: "/resources" },
                { label: "About", to: "/about" },
                { label: "Contact", to: "/contact" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="transition-colors duration-200 hover:text-[#D4AF37]"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="section-label text-[#D4AF37]">Contact</h4>
            <ul className="mt-5 space-y-4 text-sm text-slate-300">
              <li>
                <a
                  href={CONTACT.phoneHref}
                  data-testid="footer-phone"
                  className="flex items-center gap-3 transition-colors duration-200 hover:text-[#D4AF37]"
                >
                  <Phone className="h-4 w-4 text-[#D4AF37]" /> {CONTACT.phone}
                </a>
              </li>
              <li>
                <a
                  href={CONTACT.emailHref}
                  data-testid="footer-email"
                  className="flex items-center gap-3 transition-colors duration-200 hover:text-[#D4AF37]"
                >
                  <Mail className="h-4 w-4 text-[#D4AF37]" /> {CONTACT.email}
                </a>
              </li>
            </ul>
            <div className="mt-6 flex items-center gap-3">
              <a
                href={CONTACT.facebook}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook"
                aria-label="Facebook"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/20 transition-colors duration-200 hover:border-[#D4AF37] hover:text-[#D4AF37]"
              >
                <Facebook className="h-4 w-4" />
              </a>
              <a
                href={CONTACT.x}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-x"
                aria-label="X (Twitter)"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/20 transition-colors duration-200 hover:border-[#D4AF37] hover:text-[#D4AF37]"
              >
                <XIcon className="h-3.5 w-3.5" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-6">
          <p className="text-center text-xs leading-relaxed text-slate-400" data-testid="footer-copyright">
            &copy; {year} Draft &amp; Defend, a division of Summers Administrative Group. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
